export const PROJECT_DONE = '@PROJECT/PROJECT_DONE';
export const PROJECT_OPEN = '@PROJECT/PROJECT_OPEN';

export const actionCreators = {
    projectDone: (idProject) =>  ({ type: PROJECT_DONE, payload: idProject }),
    projectOpen: (idProject) =>  ({ type: PROJECT_OPEN, payload: idProject }),
};
